export const RDX_APP_API_START = 'rdx/app/api/start';
export const RDX_APP_API_END = 'rdx/app/api/end';
export const RDX_APP_API_FINISH = 'rdx/app/api/finish';
export const RDX_APP_MODULE_START = 'rdx/app/module/start';
export const RDX_APP_MODULE_END = 'rdx/app/module/end';
export const RDX_APP_LOGON = 'rdx/app/logon';
export const RDX_APP_LOGON_FREQUENCY = 'rdx/app/logon/frequency';
export const RDX_APP_SAAS = 'rdx/app/saas';
export const RDX_APP_KEEP_ALIVE = 'rdx/app/keepAlive';
export const RDX_APP_LOGOUT = 'rdx/app/logout';
export const RDX_APP_SESSIONTIMEOUT_OPEN = 'rdx/app/sessionTimeout/open';
export const RDX_APP_SESSIONTIMEOUT_RESET = 'rdx/app/sessionTimeout/reset';
export const RDX_APP_SESSIONTIMEOUT_COUNTDOWN = 'rdx/app/sessionTimeout/countdown';
export const RDX_APP_SAAS_START = 'rdx/app/saas/start';
export const RDX_APP_SAAS_END = 'rdx/app/saas/end';
export const RDX_APP_SPINNER_API_START = 'rdx/app/spinner/start';
export const RDX_APP_SPINNER_API_END = 'rdx/app/spinner/end';
export const RDX_APP_SAAS_PENDING = 'rdx/app/saas/pending';
export const RDX_APP_LOADING_TEXT_SHOWING = 'rdx/app/loading/txt/show';
export const RDX_APP_DSP = 'rdx/app/dsp';
// Loading control
export const startAPI = () => {
  return {type: RDX_APP_API_START};
};
export const endAPI = () => {
  return {type: RDX_APP_API_END};
};

export const finishApi = () => {
  return {type: RDX_APP_API_FINISH};
};
//loading with spinner controller
export const startSpinnerAPI = () => {
  return {type: RDX_APP_SPINNER_API_START};
};
export const endSpinnerAPI = () => {
  return {type: RDX_APP_SPINNER_API_END};
};
//show loading text
export const showLoadingText = (enableIndicator) => {
  return {type: RDX_APP_LOADING_TEXT_SHOWING, enableIndicator};
};
export const startSaas = () => {
  return {type: RDX_APP_SAAS_START};
};
export const pendingSaas = () => {
  return {type: RDX_APP_SAAS_PENDING};
};
export const endSaas = () => {
  return {type: RDX_APP_SAAS_END};
};
export const startModule = () => {
  return {type: RDX_APP_MODULE_START};
};
export const endModule = () => {
  return {type: RDX_APP_MODULE_END};
};

// app initial
export const logon = (logonState) => {
  return {type: RDX_APP_LOGON, logonState: logonState};
};
// logon frequency Prevent repeated logins all the time
export const logonFrequency = (saasLogonfrequency) => {
  return {type: RDX_APP_LOGON_FREQUENCY, saasLogonfrequency: saasLogonfrequency};
};
export const saasToken = (saasLogonfrequency) => {
  return {type: RDX_APP_SAAS, saasLogonfrequency: saasLogonfrequency};
};
export const logout = () => {
  return {type: RDX_APP_LOGOUT};
};
export const dspToken = () => {
  return {type: RDX_APP_DSP};
};
// session of UI timeout control
export const openSessionTimeout = () => {
  return {type: RDX_APP_SESSIONTIMEOUT_OPEN};
};
export const resetSessionTimeout = () => {
  return {type: RDX_APP_SESSIONTIMEOUT_RESET};
};
export const startCountdownSessionTimeout = () => {
  return {type: RDX_APP_SESSIONTIMEOUT_COUNTDOWN};
};
export const keepAlive = () => {
  return {type: RDX_APP_KEEP_ALIVE};
};
